import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33d9d2b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification_tooltip" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { deepCopy } from '@/js/utils/util'
import APP from '@/js/const/app'
import Icon from '@/components/atoms/Icon'
import type {
  NotificationReadStateItem,
  NotificationTooltipState,
  UnreadNotification,
} from '../types'

// PushSubscriptionの更新用

const __default__ = {
  name: 'NotificationToolTip',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const UPDATE_SUBSCRIPTION_INTERVAL = APP.PUSH_SUBSCRIPTION_EXPIRES_UPDATE_INTERVAL
// 既読バッジの更新用
const POLLING_INTERVAL = 60 * 1000

const store = useStore()
const route = useRoute()
const router = useRouter()

const message = APP.NOTIFICATION_MESSAGES
const getNotificationsReadStateTimer = ref<ReturnType<typeof setInterval> | null>(null)
const saveSubscriptionTimer = ref<ReturnType<typeof setInterval> | null>(null)

const readState = computed<NotificationReadStateItem[]>(
  () => store.getters['notification/readState']
)
const tooltipState = computed<NotificationTooltipState>(
  () => store.getters['notification/tooltipState']
)
const unreadNotifications = computed<UnreadNotification[]>(
  () => store.getters['notification/unreadNotifications']
)
const isWebPushSubscribed = computed<boolean>(() => store.getters['webPush/isSubscribed'])
const userInfo = computed(() => store.getters['auth/userInfo'])

const replaceNewLine = (msg: string | undefined) => {
  return (msg || '').replace(/\\n/g, '\n')
}

const initNotificationReadState = () => {
  getNotificationsReadStateTimer.value = setInterval(async () => {
    await store.dispatch('notification/getNotificationsReadState')
    store.commit('notification/setTooltipState', getDisplayToolTipData())
  }, POLLING_INTERVAL)
}

const pushMessage = (event: MessageEvent) => {
  const parsed = JSON.parse(event.data as string) as {
    to: string
    dateTime: string
    body: { event: string }
  }
  const nextTooltipState = deepCopy(tooltipState.value)
  if (userInfo.value.uid !== parsed.to) {
    return
  }

  store.dispatch('notification/getNotificationsReadState')

  if (Object.keys(tooltipState.value).includes(parsed.body.event)) {
    nextTooltipState[parsed.body.event] = {
      date: parsed.dateTime,
      state: true,
    }
    store.commit('notification/setTooltipState', nextTooltipState)
  }
}

const initWebPush = () => {
  saveSubscriptionTimer.value = setInterval(
    () => store.dispatch('webPush/saveSubscription'),
    UPDATE_SUBSCRIPTION_INTERVAL
  )
  navigator.serviceWorker.addEventListener('message', pushMessage)
}

const closeNotification = (notification: UnreadNotification) => {
  const state = deepCopy(tooltipState.value)
  state[notification.event].state = false
  state[notification.event].date = isWebPushSubscribed.value
    ? notification.datetime
    : notification.latestNotification.dateTime

  store.commit('notification/setTooltipState', state)
}

const notificationPage = (notification: UnreadNotification) => {
  if (route.path !== '/notification') {
    router.push({ name: 'notification', query: { actTab: notification.event } })
  }
  closeNotification(notification)
}

const getDisplayToolTipData = () => {
  const tooltipData = deepCopy(tooltipState.value)
  const targetEvents = readState.value.filter((d) => Object.keys(tooltipData).includes(d.event))
  targetEvents.forEach((d) => {
    if (d.latestNotification && d.latestNotification.dateTime !== tooltipData[d.event].date) {
      tooltipData[d.event] = {
        date: d.latestNotification.dateTime,
        state: true,
      }
    }
  })

  return tooltipData
}

const toolTipStyle = (index: number) => {
  return {
    top: `${45 * (index + 1)}px`,
  }
}

const removePushMessageEvent = () => {
  if (getNotificationsReadStateTimer.value) {
    clearInterval(getNotificationsReadStateTimer.value)
  }

  if (saveSubscriptionTimer.value) {
    clearInterval(saveSubscriptionTimer.value)
  }
  navigator.serviceWorker.removeEventListener('message', pushMessage)
}

onMounted(async () => {
  await store.dispatch('notification/getNotificationsReadState')

  if (isWebPushSubscribed.value) {
    initWebPush()
    await store.dispatch('webPush/saveSubscription')
  } else {
    initNotificationReadState()
  }
})

onBeforeUnmount(() => {
  removePushMessageEvent()
})

watch(isWebPushSubscribed, (v) => {
  removePushMessageEvent()
  if (v) {
    initWebPush()
  } else {
    initNotificationReadState()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unreadNotifications), (notification, $index) => {
      return (_openBlock(), _createBlock(_Transition, { key: $index }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "tooltip",
            style: _normalizeStyle(toolTipStyle($index)),
            "data-test": "tooltip"
          }, [
            _createElementVNode("span", {
              onClick: ($event: any) => (notificationPage(notification))
            }, _toDisplayString(replaceNewLine(_unref(message)[notification.event])), 9, _hoisted_2),
            _createElementVNode("span", {
              class: "tooltip_close_btn",
              onClick: ($event: any) => (closeNotification(notification))
            }, [
              _createVNode(_unref(Icon), {
                type: "close",
                size: "15",
                color: "color-dark3"
              })
            ], 8, _hoisted_3)
          ], 4)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})